#import "./SageGiftAccountDifferenceFields.graphql"

mutation IgnoreSageGiftAccountDifferences($ids: [ID!]!, $note: String) {
  ignoreSageGiftAccountDifferences(input: { ids: $ids, note: $note }) {
    results {
      id
      success
      error
      difference {
        ...SageGiftAccountDifferenceFields
      }
    }
  }
}
